import {environment} from '../../environments/environment';

export class MediaSource {
  mediaSourceId: number = 0;
  mediaSourceType: MediaSourceType = MediaSourceType.Image;
  name: string = '';
  alternativeText: string = '';
  filename: string = '';
  path: string = '';
  width: number = 0;
  height: number = 0;
  description: string = '';
  category: string = '';
  deleted: boolean = false;
  verticalFocusPosition: number = 0;
  horizontalFocusPosition: number = 0;
  videoUrl: string = '';
  htmlIndexUrl: string = '';
  localFullPath: string = '';
  localFullPathIndexFile: string = '';
  sentToCdn: boolean = false;
  createdAt: Date = new Date();
  updatedAt: Date = new Date();

  get fullPath(): string {
    return environment.cdnHost + this.localFullPath;
  }
  readonly isFacebookVideo: boolean = false;
}

export enum MediaSourceType {
  Unknown = 'Unknown',
  Image = 'Image',
  Video = 'Video',
  Html = 'Html',
  Pdf = 'Pdf',
  Audio = 'Audio',
}
